var company = {};
module['exports'] = company;
company.suffix = require("./suffix");



/*****************
 ** WEBPACK FOOTER
 ** ./~/faker/lib/locales/en_IND/company/index.js
 ** module id = 432
 ** module chunks = 0
 **/